import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { EnglishImprintContent } from '../components/EnglishImprintContent';
import { useLanguage } from '../contexts/LanguageContext';
export function ImpressumPage() {
  const {
    language
  } = useLanguage();
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-639">
      <Navigation data-id="element-640" />
      <main className="pt-24 pb-16" data-id="element-641">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-642">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-643">
            {language === 'de' ? 'Impressum' : 'Imprint'}
          </h1>

          {language === 'en' ? <EnglishImprintContent data-id="element-644" /> : <div className="prose prose-invert max-w-none" data-id="element-645">
              <section className="mb-8" data-id="element-646">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-647">
                  Adresse
                </h2>
                <p className="text-gray-400 leading-relaxed" data-id="element-648">
                  CRM Kraft LLC
                  <br data-id="element-649" />
                  Vertreten durch: Justus Kraft
                  <br data-id="element-650" />
                  7901 4th St. N, Ste. 300
                  <br data-id="element-651" />
                  St. Petersburg, FL 33702
                  <br data-id="element-652" />
                  United States of America
                </p>
              </section>

              <section className="mb-8" data-id="element-653">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-654">
                  Kontakt
                </h2>
                <p className="text-gray-400 leading-relaxed" data-id="element-655">
                  Telefon: +49 157 35999071
                  <br data-id="element-656" />
                  E-Mail: justus@crm-kraft.de
                </p>
              </section>

              <section className="mb-8" data-id="element-657">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-658">
                  EU-Streitschlichtung
                </h2>
                <p className="text-gray-400 leading-relaxed" data-id="element-659">
                  Die Europäische Kommission stellt eine Plattform zur
                  Online-Streitbeilegung (OS) bereit:{' '}
                  <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-660">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                  .<br data-id="element-661" />
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
              </section>

              <section data-id="element-662">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-663">
                  Verbraucherstreitbeilegung/Universalschlichtungsstelle
                </h2>
                <p className="text-gray-400 leading-relaxed" data-id="element-664">
                  Wir sind nicht bereit oder verpflichtet, an
                  Streitbeilegungsverfahren vor einer
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </section>
            </div>}
        </div>
      </main>
      <Footer data-id="element-665" />
    </div>;
}